import phantomApi from "./phantomAPI";
import ENV from '../config/env';
class PhantomService {
    getPhantomResults = () => {
        const key = ENV.PHANTOM_KEY
        return phantomApi.get(`/phantom-data?key=${key}`);
    }
}

export default new PhantomService();